const ENTER_NUMBER_STEP = 'enterNumber';
const ENTER_OTP_STEP = 'enterOtp';
const ENTER_PASSWORD_STEP = 'enterPassword';
const ADD_NUMBER_STEP = 'addNumber';
const VERIFY_OTP_STEP = 'verifyOtp';
const ACCOUNT_TYPE_LOGIN = 'login';
const ACCOUNT_TYPE_SIGNUP = 'signup';
const LOGIN_TYPE_NUMBER = 'number';
const LOGIN_TYPE_EMAIL = 'email';

export const ERROR_CODE = {
  INVALID_OTP: 'E601',
  EMAIL_ALREADY_REGISTERED: 'E132',
  INVALID_EMAIL: 'E112',
  INVALID_PASSWORD: 'E133',
  PROFANE_CONTENT_USED: 'E164'
};

export const TalkState = {
  SHOW: 0,
  NO_SHOW: 2,
  LOCAL_NO_SHOW: 3
};

export default {
  ENTER_NUMBER_STEP,
  ENTER_OTP_STEP,
  ENTER_PASSWORD_STEP,
  ADD_NUMBER_STEP,
  VERIFY_OTP_STEP,
  ACCOUNT_TYPE_LOGIN,
  ACCOUNT_TYPE_SIGNUP,
  LOGIN_TYPE_NUMBER,
  LOGIN_TYPE_EMAIL,
  ERROR_CODE
};
